(function(){
  var WA = '56996106075';

  var COLORES = {
    "Titanio Natural":"#8E8577","Natural Titanium":"#8E8577",
    "Titanio Negro":"#3C3C3C","Black Titanium":"#3C3C3C",
    "Titanio Azul":"#3B5A7A","Blue Titanium":"#3B5A7A",
    "Titanio Blanco":"#E8E4DA","White Titanium":"#E8E4DA",
    "Titanio Desierto":"#B49C84","Desert Titanium":"#B49C84",
    "Titanio":"#BFB7AC","Titanium":"#BFB7AC",
    "Negro":"#1C1C1E","Black":"#1C1C1E",
    "Negro Espacial":"#2B2B2E","Space Black":"#2B2B2E","Gris Espacial":"#53565A",
    "Medianoche":"#1F2430","Midnight":"#1F2430",
    "Blanco":"#F5F5F0","White":"#F5F5F0",
    "Blanco Estelar":"#F3EFE7","Starlight":"#F3EFE7",
    "Azul":"#3B5A7A","Blue":"#3B5A7A",
    "Celeste":"#AFC7DB","Light Blue":"#AFC7DB",
    "Azul Sierra":"#9BB5CE","Sierra Blue":"#9BB5CE",
    "Azul Alpino":"#3A4A63","Alpine Blue":"#3A4A63",
    "Azul marino":"#2A2F6B","Azul Marino":"#2A2F6B","Navy":"#2A2F6B",
    "Ultramarino":"#4A52C4","Ultramarine":"#4A52C4",
    "Rosa":"#F4C7CE","Pink":"#F4C7CE",
    "Rosado":"#EBC8C9",
    "Oro Rosa":"#E3B7A8","Rose Gold":"#E3B7A8",
    "Coral":"#F08A72",
    "Amarillo":"#F5E27A","Yellow":"#F5E27A",
    "Verde":"#8A9A7E","Green":"#8A9A7E",
    "Verde Oscuro":"#37742D","Verde Noche":"#394C3F","Verde Alpino":"#52635A",
    "Verde Agua":"#67A299","Menta":"#A8D8C8",
    "Lila":"#C8B6E2","Lavanda":"#C8B6E2","Purple Haze":"#C8B6E2",
    "Morado":"#7D6E8C","Purpura":"#7D6E8C","Púrpura":"#7D6E8C","Purple":"#7D6E8C",
    "Purpura Oscuro":"#5B4A63","Púrpura Oscuro":"#5B4A63","Deep Purple":"#5B4A63",
    "Naranja":"#D4572A","Orange":"#D4572A",
    "Naranja Cosmico":"#E06A2B","Naranja Cósmico":"#E06A2B",
    "Rojo":"#B91C2E","Red":"#B91C2E","PRODUCT RED":"#B91C2E",
    "Grafito":"#4A4A4A","Graphite":"#4A4A4A",
    "Dorado":"#D4AF6A",
    "Oro":"#E8D4B0","Gold":"#E8D4B0",
    "Plata":"#E3E3E3","Plateado":"#E3E3E3","Silver":"#E3E3E3",
    "Arena":"#D8C7AE","Melocoton":"#F2C6A8","Melocotón":"#F2C6A8",
    // Nombres oficiales Apple (es-LatAm)
    "Morado Oscuro":"#594F63",
    "Titanio del Desierto":"#BFA48F",
    "Verde Medianoche":"#4E5851",
    "Azul Pacífico":"#2F4B5F",
    "Azul Medianoche":"#232A31",
    "(PRODUCT)RED":"#BA0C2E",
    "Verde Azulado":"#B0D4D2",
    "Azul Neblina":"#9FB6CD",
    "Salvia":"#B7C2A6",
    "Blanco Nube":"#F2F1EC",
    "Oro Claro":"#E9DCC0",
    "Azul Cielo":"#C9DBEA",
    "Azul Profundo":"#2F3A4F",
    "Rosa Pálido":"#F3DCDC",
    "Glaciar":"#D9E3E8",
    "Burdeos":"#6B1F2E"
  };

  // Tono de cada color por generación (sacado de las fotos de cada modelo)
  var POR_GEN = {
    11: {"negro":"#1F2020","blanco":"#F9F6EF","morado":"#D1CDDA","amarillo":"#FFE681","verde":"#AEE1CD","(product)red":"#BA0C2E",
         "oro":"#F9E5C9","verde medianoche":"#4E5851","plata":"#EBEBE3","gris espacial":"#535150"},
    12: {"negro":"#25212B","blanco":"#F6F2EF","morado":"#B7AFE6","verde":"#D8EFD5","azul":"#023B63","(product)red":"#BA0C2E",
         "azul pacifico":"#2E4452","oro":"#FCEBD3","plata":"#E2E4E1","grafito":"#52514D"},
    13: {"azul medianoche":"#232A31","rosa":"#FADDD7","blanco estelar":"#FAF6F2","verde":"#394C38","(product)red":"#BF0013","azul":"#276787",
         "grafito":"#54524F","azul sierra":"#A7C1D9","oro":"#FAE7CF","verde alpino":"#576856","plata":"#F1F2ED"},
    14: {"(product)red":"#E11C2A","morado":"#E5DDEA","azul":"#A0B4C7","amarillo":"#F9E479","blanco estelar":"#FAF6F2","azul medianoche":"#222930",
         "negro espacial":"#403E3D","oro":"#F4E8CE","plata":"#F0F2F2","morado oscuro":"#594F63"},
    15: {"negro":"#35393B","azul":"#D4E4ED","verde":"#E3E9D6","amarillo":"#F3EEC1","rosa":"#F5DCE0",
         "titanio natural":"#BAB4A9","titanio negro":"#3B3C3E","titanio blanco":"#F2F1ED","titanio azul":"#3F4555"},
    16: {"blanco":"#FAFAFA","rosa":"#F2ADDA","verde azulado":"#B0D4D2","ultramarino":"#9AADF6","negro":"#3C4042",
         "titanio natural":"#C2BCB2","titanio del desierto":"#BFA48F","titanio negro":"#3C3C3D","titanio blanco":"#F2F1EC"},
    17: {"azul neblina":"#ADBED4","blanco":"#F2F3F0","lavanda":"#E8DDEC","negro":"#4A4B4D","salvia":"#B9C59C",
         "azul profundo":"#353A46","naranja cosmico":"#F17B39","plata":"#E7E7E5",
         "negro espacial":"#2E2E30","blanco nube":"#F2F1EC","oro claro":"#E9DCC0","azul cielo":"#C9DBEA"},
    18: {"negro":"#1B1A1D","plata":"#D3D3D3","glaciar":"#9AA8BA","burdeos":"#46272E"}
  };

  var COLN = null;

  var ACC = 'áàäâãéèëêíìïîóòöôõúùüûñç';
  var PLAIN = 'aaaaaeeeeiiiiooooouuuunc';

  var corrigiendo = false;

  function enFicha(){ return String(location.pathname).indexOf('/products/') !== -1; }

  function esDigito(c){ return c >= '0' && c <= '9'; }

  function norm(s){
    s = String(s).toLowerCase().split('-').join(' ');
    var out = '';
    for(var i = 0; i < s.length; i++){
      var k = ACC.indexOf(s.charAt(i));
      out += (k === -1 ? s.charAt(i) : PLAIN.charAt(k));
    }
    return out;
  }

  function limpiarNombre(t){
    t = String(t);
    var cortes = [' - ', ' – ', ' -', ' –'];
    for(var i = 0; i < cortes.length; i++){
      var k = t.indexOf(cortes[i]);
      if(k > 0) return t.slice(0, k).trim();
    }
    return t.trim();
  }

  function partes(opt){
    var t = (opt.textContent || '').trim();
    var arr = t.split(' / ');
    for(var i = 0; i < arr.length; i++) arr[i] = arr[i].trim();
    return arr;
  }

  function disponible(opt){ return opt.getAttribute('data-available') === 'true'; }

  function contenedor(){ return document.querySelector('[data-riff-variants]'); }
  function grupos(w){ return w.querySelectorAll('.riff-variants__grupo'); }

  function seleccion(w){
    var g = grupos(w), s = [];
    for(var i = 0; i < g.length; i++){
      var c = g[i].querySelector('input:checked');
      s.push(c ? c.value : null);
    }
    return s;
  }

  function colorDe(nombre){
    if(!COLN){
      COLN = {};
      for(var k in COLORES){ if(COLORES.hasOwnProperty(k)) COLN[norm(k)] = COLORES[k]; }
    }
    var n = norm(nombre).trim();
    var g = generacionDe(norm(tituloProducto()));
    if(g && POR_GEN[g] && POR_GEN[g][n]) return POR_GEN[g][n];
    return COLN[n] || null;
  }

  function pintarSwatches(){
    var ls = document.querySelectorAll('.riff-variants__swatch-label');
    for(var i = 0; i < ls.length; i++){
      var t = ls[i].getAttribute('title');
      var c = t ? colorDe(t) : null;
      if(c) ls[i].style.background = c;
    }
  }

  function pintarNombres(w){
    var g = grupos(w);
    for(var i = 0; i < g.length; i++){
      var lab = g[i].querySelector('.riff-variants__label');
      if(!lab) continue;
      var sp = lab.querySelector('.riff-variants__valor');
      if(!sp){
        var base = (lab.textContent || '').trim();
        while(base.length && base.charAt(base.length - 1) === ':') base = base.slice(0, -1).trim();
        lab.textContent = base + ':';
        sp = document.createElement('span');
        sp.className = 'riff-variants__valor';
        lab.appendChild(sp);
      }
      var c = g[i].querySelector('input:checked');
      sp.textContent = c ? c.value : '';
    }
  }

  function ajustar(){
    var w = contenedor();
    if(!w) return;
    var select = w.querySelector('[data-riff-variant-select]');
    if(!select){ pintarNombres(w); return; }

    var ops = select.options;
    var hayDatos = false, z;
    for(z = 0; z < ops.length; z++){ if(disponible(ops[z])){ hayDatos = true; break; } }

    var sel = seleccion(w);

    var match = null, a, b;
    for(a = 0; a < ops.length; a++){
      var o = partes(ops[a]), ok = true;
      for(b = 0; b < sel.length; b++){ if(o[b] !== sel[b]){ ok = false; break; } }
      if(ok){ match = ops[a]; break; }
    }

    if(!match && hayDatos && !corrigiendo){
      var alt = null, k;
      for(k = 0; k < ops.length; k++){
        if(!disponible(ops[k])) continue;
        if(partes(ops[k])[0] === sel[0]){ alt = ops[k]; break; }
      }
      if(!alt){
        for(k = 0; k < ops.length; k++){ if(disponible(ops[k])){ alt = ops[k]; break; } }
      }
      if(alt){
        corrigiendo = true;
        var vals = partes(alt), g = grupos(w), ultimo = null, m;
        for(k = 0; k < g.length && k < vals.length; k++){
          var ins = g[k].querySelectorAll('input[type="radio"]');
          for(m = 0; m < ins.length; m++){
            if(ins[m].value === vals[k]){ ins[m].disabled = false; ins[m].checked = true; ultimo = ins[m]; break; }
          }
        }
        corrigiendo = false;
        if(ultimo){
          ultimo.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    if(hayDatos){
      var gg = grupos(w), i2, j2, c2, d2;
      for(i2 = 0; i2 < gg.length; i2++){
        var radios = gg[i2].querySelectorAll('input[type="radio"]');
        for(j2 = 0; j2 < radios.length; j2++){
          var existe = false;
          for(c2 = 0; c2 < ops.length; c2++){
            if(!disponible(ops[c2])) continue;
            var oo = partes(ops[c2]), compatible = true;
            for(d2 = 0; d2 < i2; d2++){ if(oo[d2] !== sel[d2]){ compatible = false; break; } }
            if(compatible && oo[i2] === radios[j2].value){ existe = true; break; }
          }
          radios[j2].disabled = !existe;
        }
      }
    }

    pintarNombres(w);
  }

  function textoEnvio(){
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Santiago', weekday: 'short', hour: 'numeric', hour12: false
      }).formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; });
      var dia = p.weekday;
      var hora = parseInt(p.hour, 10);
      if(hora === 24) hora = 0;
      if(dia === 'Sat' || dia === 'Sun') return 'Despachamos el lunes';
      if(hora < 15) return 'Despacho hoy si compras antes de las 15:00';
      if(dia === 'Fri') return 'Despachamos el lunes';
      return 'Despachamos mañana';
    } catch(e){
      return 'Despacho el mismo día comprando antes de las 15:00';
    }
  }

  // --- Ficha: entrega, textos y orden ---

  function formularioCompra(){
    if(!enFicha()) return null;
    var cont = document.querySelector('.product__info-container') ||
               document.querySelector('.product__info-wrapper') ||
               document;
    return cont.querySelector('.product-form') ||
           cont.querySelector('form[action*="/cart/add"]');
  }

  function filaEntrega(icono, titulo, texto){
    var f = document.createElement('div');
    f.className = 'riff-entrega__fila';
    var i = document.createElement('div');
    i.className = 'riff-entrega__icono';
    i.textContent = icono;
    var b = document.createElement('div');
    var t = document.createElement('p');
    t.className = 'riff-entrega__titulo';
    t.textContent = titulo;
    var x = document.createElement('p');
    x.className = 'riff-entrega__texto';
    x.textContent = texto;
    b.appendChild(t);
    b.appendChild(x);
    f.appendChild(i);
    f.appendChild(b);
    return f;
  }

  function ponerEntrega(){
    if(!enFicha()) return;
    if(document.querySelector('.riff-entrega')) return;
    var f = formularioCompra();
    if(!f || !f.parentNode) return;
    var stock = document.querySelector('.riff-stock');
    if(stock && stock.querySelector('.riff-stock__texto--agotado')){
      stock.setAttribute('data-riff-agotado', '1');
    }
    var card = document.createElement('div');
    card.className = 'riff-entrega';
    card.appendChild(filaEntrega('🏬', 'Retiro en tienda hoy',
      'Av. Nueva Providencia 2250, Of. 703, Providencia · Metro Los Leones'));
    card.appendChild(filaEntrega('🚚', textoEnvio(),
      'Llega en 1 a 2 días hábiles en Santiago y 2 a 5 en regiones, por Chilexpress.'));
    f.parentNode.insertBefore(card, f.nextSibling);
  }

  function textosFicha(){
    if(!enFicha()) return;
    var promo = document.querySelector('.riff-info__promo-texto span');
    if(promo && promo.textContent.indexOf('OEM') === -1) promo.textContent = 'AirPods OEM de regalo';
    var labels = document.querySelectorAll('.main-atc__label__text');
    for(var i = 0; i < labels.length; i++){
      if(labels[i].textContent.trim().toUpperCase() === 'COMPRA CON TARJETA') labels[i].textContent = 'Comprar con tarjeta';
    }
    var wa = document.querySelector('.riff-whatsapp-buy');
    if(wa && !wa.querySelector('.riff-whatsapp-buy__nota')){
      var n = document.createElement('span');
      n.className = 'riff-whatsapp-buy__nota';
      n.textContent = 'Un vendedor te atiende por WhatsApp y coordinas el pago por transferencia.';
      wa.appendChild(n);
    }
  }

  // --- Parte de pago (solo en la ficha) ---

  function ponerPartePago(){
    if(!enFicha()) return;
    if(document.querySelector('.riff-tradein')) return;
    var t = tituloProducto();
    if(!t || norm(t).indexOf('iphone') === -1) return;
    var ancla = document.querySelector('.riff-entrega') ||
                formularioCompra() ||
                document.querySelector('.riff-stock');
    if(!ancla || !ancla.parentNode) return;

    var caja = document.createElement('div');
    caja.className = 'riff-tradein';

    var h = document.createElement('p');
    h.className = 'riff-tradein__titulo';
    h.textContent = '♻️ Tu iPhone como parte de pago';

    var p = document.createElement('p');
    p.className = 'riff-tradein__texto';
    p.textContent = 'Válido solo en nuestra tienda: la evaluación se hace de manera presencial, con el equipo en la mano. Recibimos iPhone del 11 en adelante.';

    var a = document.createElement('a');
    a.className = 'riff-tradein__cta';
    a.target = '_blank';
    a.rel = 'noopener';
    a.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola! Quiero dejar mi iPhone como parte de pago por un ' + limpiarNombre(t));
    a.textContent = 'Escríbeme por WhatsApp';

    caja.appendChild(h);
    caja.appendChild(p);
    caja.appendChild(a);
    ancla.parentNode.insertBefore(caja, ancla.nextSibling);
  }

  // --- Batería según el modelo ---

  function generacionDe(s){
    var gens = ['18','17','16','15','14','13','12','11'];
    for(var i = 0; i < gens.length; i++){
      if(s.indexOf('iphone ' + gens[i]) !== -1) return parseInt(gens[i], 10);
    }
    if(s.indexOf('iphone air') !== -1) return 17;
    return 0;
  }

  function textoBateria(titulo){
    var s = norm(titulo);
    if(s.indexOf('iphone') === -1) return null;
    if(s.indexOf('open box') !== -1) return 'Batería al 100% y caja original del modelo';
    if(s.indexOf('sellado') !== -1) return 'Equipo sellado de fábrica';
    if(s.indexOf('semi nuevo') === -1 && s.indexOf('reacondicionado') === -1) return 'Equipo nuevo, sellado de fábrica';
    var g = generacionDe(s);
    if(g >= 16) return 'Batería original, entre 90% y 98% de salud';
    if(g >= 11) return 'Batería nueva certificada por nuestro técnico, al 100%';
    return null;
  }

  function tituloProducto(){
    var h = document.querySelector('.product__title h1') || document.querySelector('h1');
    return h ? h.textContent.trim() : '';
  }

  function ponerBateria(){
    if(!enFicha()) return;
    var t = tituloProducto();
    if(!t) return;
    var txt = textoBateria(t);
    if(!txt) return;
    var caja = document.querySelector('.riff-info__grid');
    if(!caja) return;
    var todos = caja.querySelectorAll('*');
    for(var i = 0; i < todos.length; i++){
      var e = todos[i];
      if(e.children.length) continue;
      var orig = e.textContent || '';
      if(norm(orig).indexOf('bateria') === -1) continue;
      if(e.getAttribute('data-riff-bat') === '1') return;
      e.setAttribute('data-riff-bat', '1');
      var pref = '';
      if(orig.charCodeAt(0) > 8000){
        var esp = orig.indexOf(' ');
        if(esp > 0 && esp < 4) pref = orig.slice(0, esp + 1);
      }
      e.textContent = pref + txt;
      return;
    }
  }

  // --- Cómo certificamos (home y ficha de producto) ---

  var PASOS = [
    ['Diagnóstico técnico', 'Revisamos pantalla, cámaras, parlantes, micrófono, carga, Face ID y botones, uno por uno.'],
    ['Batería', 'Del iPhone 11 al 15 Pro Max instalamos una batería nueva certificada por nuestro técnico: sale al 100%. Del 16 en adelante conserva su batería original, entre 90% y 98% de salud.'],
    ['Limpieza y armado', 'El equipo se limpia y se prepara con su cargador, mica y carcasa.'],
    ['Garantía', 'Sale con 12 meses de garantía Riffstore.']
  ];

  function seccionDe(el){
    var n = el;
    while(n && n !== document.body){
      if(n.classList && n.classList.contains('shopify-section')) return n;
      n = n.parentNode;
    }
    return null;
  }

  function anclaCert(){
    var home = document.querySelector('[id$="custom_liquid_PFcX6R"]');
    if(home) return home;
    if(!enFicha()) return null;
    var prod = document.querySelector('.product');
    if(prod) return seccionDe(prod);
    return null;
  }

  function ponerCertificacion(){
    if(document.querySelector('.riff-cert')) return;
    var ancla = anclaCert();
    if(!ancla || !ancla.parentNode) return;

    var sec = document.createElement('div');
    sec.className = 'riff-cert';

    var h = document.createElement('h2');
    h.className = 'riff-cert__titulo';
    h.textContent = 'Cómo certificamos cada equipo';
    sec.appendChild(h);

    var grid = document.createElement('div');
    grid.className = 'riff-cert__grid';
    for(var i = 0; i < PASOS.length; i++){
      var c = document.createElement('div');
      c.className = 'riff-cert__paso';
      var n = document.createElement('span');
      n.className = 'riff-cert__num';
      n.textContent = String(i + 1);
      var tt = document.createElement('p');
      tt.className = 'riff-cert__paso-titulo';
      tt.textContent = PASOS[i][0];
      var d = document.createElement('p');
      d.className = 'riff-cert__paso-texto';
      d.textContent = PASOS[i][1];
      c.appendChild(n);
      c.appendChild(tt);
      c.appendChild(d);
      grid.appendChild(c);
    }
    sec.appendChild(grid);
    ancla.parentNode.insertBefore(sec, ancla.nextSibling);
  }

  // --- Tarjeta "iPhone" del home: lleva al catálogo ---

  function linkCatalogo(){
    var as = document.querySelectorAll('a.riff-categorias__card[href*="/collections/celulares"]');
    for(var i = 0; i < as.length; i++) as[i].setAttribute('href', '/pages/catalogo');
  }

  // --- Categorías: solo iPhone y Accesorios ---

  function ocultarCategorias(){
    var cards = document.querySelectorAll('.riff-categorias__card');
    for(var i = 0; i < cards.length; i++){
      var s = norm(cards[i].textContent || '');
      var href = norm(cards[i].getAttribute('href') || '');
      if(s.indexOf('ipad') !== -1 || s.indexOf('macbook') !== -1 ||
         href.indexOf('/ipad') !== -1 || href.indexOf('/macbook') !== -1){
        cards[i].style.display = 'none';
      }
    }
  }

  // --- Precio transferencia en las tarjetas del home ---

  function soloDigitos(s){
    var out = '';
    for(var i = 0; i < s.length; i++){ if(esDigito(s.charAt(i))) out += s.charAt(i); }
    return out;
  }

  function miles(n, sep){
    var s = String(n), out = '', cuenta = 0;
    for(var i = s.length - 1; i >= 0; i--){
      out = s.charAt(i) + out;
      cuenta++;
      if(cuenta % 3 === 0 && i > 0) out = sep + out;
    }
    return out;
  }

  function precioDual(){
    var els = document.querySelectorAll('.riff-bestsellers__precio');
    for(var i = 0; i < els.length; i++){
      var el = els[i];
      if(el.getAttribute('data-riff-dual') === '1') continue;
      var txt = (el.textContent || '').trim();
      var digitos = soloDigitos(txt);
      if(digitos.length < 4) continue;
      var tarjeta = parseInt(digitos, 10);
      if(!tarjeta) continue;
      el.setAttribute('data-riff-dual', '1');
      var transferencia = Math.round(tarjeta * 0.94);
      el.textContent = '$' + miles(transferencia, '.');
      var nota = document.createElement('span');
      nota.className = 'riff-precio-nota';
      nota.textContent = '$' + miles(tarjeta, '.') + ' con tarjeta';
      el.parentNode.insertBefore(nota, el.nextSibling);
    }
  }

  // --- Precio de la ficha según la variante elegida ---

  var PRECIOS = null;
  var PRECIOS_HANDLE = '';
  var FOTOS = {};

  function handleProducto(){
    var p = String(location.pathname);
    var k = p.indexOf('/products/');
    if(k === -1) return '';
    var h = p.slice(k + 10);
    var q = h.indexOf('/');
    if(q !== -1) h = h.slice(0, q);
    return h;
  }

  function cargarPrecios(cb){
    var h = handleProducto();
    if(!h) return;
    if(PRECIOS && PRECIOS_HANDLE === h){ cb(); return; }
    fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if(!p || !p.variants) return;
      var m = {};
      for(var i = 0; i < p.variants.length; i++){
        m[String(p.variants[i].id)] = Math.round(p.variants[i].price / 100);
        var fm = p.variants[i].featured_media;
        if(fm && fm.id) FOTOS[String(p.variants[i].id)] = String(fm.id);
      }
      PRECIOS = m;
      PRECIOS_HANDLE = h;
      cb();
    }).catch(function(){});
  }

  function pintarPrecioFicha(){
    if(!PRECIOS) return;
    var w = contenedor();
    if(!w) return;
    var select = w.querySelector('[data-riff-variant-select]');
    if(!select || !select.value) return;
    var tarjeta = PRECIOS[String(select.value)];
    if(!tarjeta) return;
    var transferencia = Math.round(tarjeta * 0.94);
    var grande = document.querySelector('.riff-info__precio-monto-grande');
    var chico = document.querySelector('.riff-info__precio-secundario strong');
    if(grande) grande.textContent = '$' + miles(transferencia, '.');
    if(chico) chico.textContent = '$' + miles(tarjeta, '.');
  }

  function precioFicha(){
    if(!enFicha()) return;
    cargarPrecios(pintarPrecioFicha);
  }

  // --- Foto del color elegido: mueve la galería a la imagen de la variante ---

  function mostrarFoto(){
    var w = contenedor();
    if(!w) return;
    var select = w.querySelector('[data-riff-variant-select]');
    if(!select || !select.value) return;
    var mid = FOTOS[String(select.value)];
    if(!mid) return;
    var g = document.querySelector('media-gallery');
    if(!g || typeof g.setActiveMedia !== 'function' || !g.id) return;
    var pref = g.id.replace('MediaGallery-', '');
    if(!document.querySelector('[data-media-id="' + pref + '-' + mid + '"]')) return;
    try { g.setActiveMedia(pref + '-' + mid, true); } catch(e){}
  }

  function fotoFicha(){
    if(!enFicha()) return;
    cargarPrecios(function(){ pintarPrecioFicha(); mostrarFoto(); });
  }

  function esSelectVariante(el){
    return !!(el && el.getAttribute && el.getAttribute('data-riff-variant-select') !== null);
  }

  // --- Formato chileno: la coma de miles pasa a punto ---

  function puntosEnMiles(s){
    var out = '';
    for(var i = 0; i < s.length; i++){
      var c = s.charAt(i);
      if(c === ',' && i > 0 && esDigito(s.charAt(i - 1)) &&
         esDigito(s.charAt(i + 1)) && esDigito(s.charAt(i + 2)) && esDigito(s.charAt(i + 3)) &&
         !esDigito(s.charAt(i + 4))){
        out += '.';
      } else {
        out += c;
      }
    }
    return out;
  }

  function normalizarMoneda(){
    if(!document.body) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var n, cambios = [];
    while((n = w.nextNode())){
      var t = n.nodeValue;
      if(!t) continue;
      if(t.indexOf(',') === -1) continue;
      if(t.indexOf('$') === -1) continue;
      var nuevo = puntosEnMiles(t);
      if(nuevo !== t) cambios.push([n, nuevo]);
    }
    for(var i = 0; i < cambios.length; i++) cambios[i][0].nodeValue = cambios[i][1];
  }

  function arrancar(){
    pintarSwatches();
    var w = contenedor();
    if(w){
      var ins = w.querySelectorAll('input[type="radio"]');
      for(var i = 0; i < ins.length; i++){
        if(ins[i].getAttribute('data-riff-bound') === '1') continue;
        ins[i].setAttribute('data-riff-bound', '1');
        ins[i].addEventListener('change', ajustar);
      }
      ajustar();
    }
    ponerEntrega();
    textosFicha();
    ponerPartePago();
    ponerBateria();
    ponerCertificacion();
    ocultarCategorias();
    linkCatalogo();
    precioDual();
    precioFicha();
    normalizarMoneda();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  setTimeout(arrancar, 900);
  setTimeout(arrancar, 2500);
  document.addEventListener('change', function(e){
    if(esSelectVariante(e.target)) fotoFicha();
    setTimeout(normalizarMoneda, 350);
  }, true);
  document.addEventListener('click', function(){ setTimeout(normalizarMoneda, 600); }, true);
})();
